import Link from "next/link";

interface Neighbourhood {
  label: string;
  city: string;
  slug: string;
  id: number;
}

interface NeighbourhoodListProps {
  neighbourhoods: Neighbourhood[];
}

const NeighbourhoodList: React.FC<NeighbourhoodListProps> = ({
  neighbourhoods,
}) => {
  return (
    <div className="flex gap-3 flex-col px-2 py-2">
      <h2 className="text-lg font-semibold">
        Search Bungalows for sale by Neighbourhoods
      </h2>
      {neighbourhoods.map((item: Neighbourhood, index: number) => (
        <Link
          href={`/city/${item.city}/${item.slug}`}
          key={index}
          className="px-2 py-2"
        >
          <a className="text-blue-500">
            {item.label} Bungalows for Sale | Just Bungalows for sale in{" "}
            {item.city} Real Estate
          </a>
        </Link>
      ))}
    </div>
  );
};

export default NeighbourhoodList;
